var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBankIdDnaElementWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 87,
    viewBox: "0 0 119 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6071 23.8571H19.9214C17.83 23.8571 16 22.0238 16 19.9286C16 17.8333 17.83 16 19.9214 16H35.6071C37.6986 16 39.5286 17.8333 39.5286 19.9286C39.5286 22.0238 37.6986 23.8571 35.6071 23.8571Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6071 55.2857H19.9214C17.83 55.2857 16 53.4524 16 51.3572C16 49.2619 17.83 47.4286 19.9214 47.4286H35.6071C37.6986 47.4286 39.5286 49.2619 39.5286 51.3572C39.5286 53.4524 37.6986 55.2857 35.6071 55.2857Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6071 71H19.9214C17.83 71 16 69.1667 16 67.0715C16 64.9762 17.83 63.1429 19.9214 63.1429H35.6071C37.6986 63.1429 39.5286 64.9762 39.5286 67.0715C39.5286 69.1667 37.6986 71 35.6071 71Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9786 39.5714H51.2929C49.2014 39.5714 47.3714 37.7381 47.3714 35.6429C47.3714 33.5476 49.2014 31.7143 51.2929 31.7143H66.9786C69.07 31.7143 70.9 33.5476 70.9 35.6429C70.9 37.7381 69.07 39.5714 66.9786 39.5714Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9786 55.2857H51.2929C49.2014 55.2857 47.3714 53.4524 47.3714 51.3572C47.3714 49.2619 49.2014 47.4286 51.2929 47.4286H66.9786C69.07 47.4286 70.9 49.2619 70.9 51.3572C70.9 53.4524 69.07 55.2857 66.9786 55.2857Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35 23.8571H82.6643C80.5729 23.8571 78.7429 22.0238 78.7429 19.9286C78.7429 17.8333 80.5729 16 82.6643 16H98.35C100.441 16 102.271 17.8333 102.271 19.9286C102.271 22.0238 100.441 23.8571 98.35 23.8571Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35 39.5714H82.6643C80.5729 39.5714 78.7429 37.7381 78.7429 35.6429C78.7429 33.5476 80.5729 31.7143 82.6643 31.7143H98.35C100.441 31.7143 102.271 33.5476 102.271 35.6429C102.271 37.7381 100.441 39.5714 98.35 39.5714Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.35 71H82.6643C80.5729 71 78.7429 69.1667 78.7429 67.0715C78.7429 64.9762 80.5729 63.1429 82.6643 63.1429H98.35C100.441 63.1429 102.271 64.9762 102.271 67.0715C102.271 69.1667 100.441 71 98.35 71Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankIdDnaElementWhite);
export default __webpack_public_path__ + "static/media/BankID-DNA-element-white.4b7d630a37045a843943f791e9d4145d.svg";
export { ForwardRef as ReactComponent };